import Vue from 'vue'
import Vuex, { ActionContext } from 'vuex'
import auth from '@/store/modules/auth'
import administration from '@/store/modules/administration'
import catalogue from '@/store/modules/catalogue'
import ui from '@/store/modules/ui'
import { IAuthState } from './modules/auth/state'
import { IAdministrationState } from './modules/administration/state'
import { ICatalogueState } from './modules/catalogue/state'
import { IUiState } from './modules/ui/state'
import { AxiosPromise } from 'axios'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AloError } from '@/models/alo/AloError'
import { ApiResultCode } from '@/enum/ApiResultCode'
import { StateItem } from '@/models/alo/StateItem'
import { AloBase } from '@/models/alo/AloBase'
import  types from '@/store/all-action-types'
import cloneDeep from 'clone-deep'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export interface IRootState {  
  auth: IAuthState
  administration:IAdministrationState
  catalogue:ICatalogueState
  ui:IUiState
}

const store = new Vuex.Store<IRootState>({    
  modules: {
    auth,
    administration,
    catalogue,
    ui
  },  
  strict: debug
})

export default store

const initialStateCopy = cloneDeep(store.state)

export function resetState() {        
  const state = cloneDeep(initialStateCopy) as IRootState     
  state.auth.authStatus = store.state.auth.authStatus
  state.auth.redirectPath = store.state.auth.redirectPath
  console.log("redirectPath",store.state.auth.redirectPath)
  store.replaceState(state)  
}

export function loadInitalData() {
  store.dispatch(types.CATALOGUE_REFERENCE_ENSURE)
  store.dispatch(types.CATALOGUE_MARQUE_ENSURE)  
  store.dispatch(types.CATALOGUE_TREE_ENSURE)
}

export const emptyAction = <T,TS>(context: ActionContext<TS, IRootState>,resquestComit:string,successComit:string,errorComit:string,emptyRequest: () => AxiosPromise<AlrContainer<T>>) => {
  return new Promise<T>((resolve, reject) => {
    context.commit(resquestComit)
    emptyRequest()
      .then(resp => {
        if (resp.data.resultCode == ApiResultCode.Ok) {
          const item = resp.data.data as T            
          context.commit(successComit, item)
          resolve(item)            

        } else {            
          context.commit(errorComit)
          if(resp.data.resultCode == ApiResultCode.MissingIdentityToken) {                            
            store.dispatch(types.AUTH_AUTO_LOGOUT_REQUEST)
          }
          store.dispatch(types.UI_ERROR_MESSAGE,{origine:resquestComit,message: (resp.data.data as AloError).errorMessage})
          reject((resp.data.data as AloError).errorMessage)
        }
      })
      .catch(err => {          
        context.commit(errorComit)
        store.dispatch(types.UI_ERROR_MESSAGE,{origine:resquestComit,message: errorComit})
        reject(err)
      })
  })
}

export const payloadAction = <T,TS>(context: ActionContext<TS, IRootState>,
    resquestComit:string,
    successComit:string,
    errorComit:string,
    payloadRequest: (payload:any) => AxiosPromise<AlrContainer<T>>, 
    payload:any
  ) => {
  return new Promise<T>((resolve, reject) => {
    context.commit(resquestComit)
    payloadRequest(payload)
      .then(resp => {
        if (resp.data.resultCode == ApiResultCode.Ok) {
          const item = resp.data.data as T            
          context.commit(successComit, item)
          resolve(item)            

        } else {            
          context.commit(errorComit)
          if(resp.data.resultCode == ApiResultCode.MissingIdentityToken) {                            
            store.dispatch(types.AUTH_AUTO_LOGOUT_REQUEST)
          }
          store.dispatch(types.UI_ERROR_MESSAGE,{origine:resquestComit,message: (resp.data.data as AloError).errorMessage})
          reject((resp.data.data as AloError).errorMessage)
        }
      })
      .catch(err => {          
        context.commit(errorComit)
        store.dispatch(types.UI_ERROR_MESSAGE,{origine:resquestComit,message: errorComit})
        reject(err)
      })
  })
}

export const actionEnsure = <T,TS>(context: ActionContext<TS, IRootState>,resquestAction:string, stateItemToCheck:StateItem<any>|null, id?:number ) => {    
  if(!stateItemToCheck || stateItemToCheck.expireAt < new Date()) {    
    return id?context.dispatch(resquestAction,id):context.dispatch(resquestAction)
  }
  return new Promise<T>((resolve, reject) => {
    resolve(stateItemToCheck.item)
  })
}